// Third-party
import React from 'react';

// Components
import { formatLocalizedString, formatMessage } from '@/utils/i18n';
import { InfoTooltip } from '@/views/components/tooltips';
import { PillLabel } from '@/views/components/misc';

// Types
import RiskProfileItem from '@/types/risk-profile-item';
import { StateOmniRiskProfileConfig } from '@/types/risk-profiles/omni/omni-risk-profile-context-types';

type Props = {
  profile: RiskProfileItem | StateOmniRiskProfileConfig;
  isComparisonRiskProfile: boolean;
  dark?: boolean;
};

const ComparisonRiskProfileLabel = ({ profile, isComparisonRiskProfile, dark }: Props) => {
  const getComparisonRiskProfileDisclaimer = () => {
    if (!isComparisonRiskProfile) {
      return undefined;
    }

    return [
      <InfoTooltip
        key="RiskProfile.ComparisonRiskProfileTooltip"
        title={formatMessage('RiskProfile.ComparisonRiskProfileTooltip.Title')}
        message={formatMessage('RiskProfile.ComparisonRiskProfileTooltip.Body')}
        dark={dark}
      />,
    ];
  };

  return <PillLabel withTooltip className="pill-green" text={formatLocalizedString(profile.title)} customElements={getComparisonRiskProfileDisclaimer()} />;
};

export default ComparisonRiskProfileLabel;
